import { Button, Col, Form, Input, Row } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '../../../../../common/components';
import { AppFormProps } from '../../../../../common/interfaces';
import { defineInputStatus } from '../../../../../common/utils';
import { HostingAccountFormFields, HostingAccountFormInputs } from '../../../hostings.interfaces';

interface Props extends AppFormProps<typeof HostingAccountFormInputs, HostingAccountFormFields> {}

export const HostingAccountsFormView: FC<Props> = ({
  form,
  formName,
  formType,
  initialValues,
  isFormLoading,
  validationSchema,
  formErrors,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      initialValues={ initialValues }
      disabled={ isFormLoading }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item
        label="Логін"
        style={{ marginBottom: 5 }}
        name={ HostingAccountFormInputs.Login }
        hasFeedback
        help={ formErrors?.login }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.login) }
        rules={ validationSchema.login }
      >
        <Input allowClear/>
      </Form.Item>

      <Form.Item
        label="Пароль"
        name={ HostingAccountFormInputs.Password }
        hasFeedback
        help={ formErrors?.password }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.password) }
        rules={ validationSchema.password }
      >
        <Input.Password allowClear/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }} noStyle>
        <Row gutter={ [16, 16] }>
          <Col flex={ 'auto' }>
            <ButtonSuccess block loading={ isFormLoading } type="primary" htmlType="submit">
              { formType === 'edit' ? 'Зберегти' : 'Додати' }
            </ButtonSuccess>
          </Col>
          <Col>
            <Button type="default" onClick={ handleBack }>
              Відмінити
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};
